const colors = {
  dark: "#333",
  light: "#fff",
  darkblue: "#354D76",
  lightBeige: "#C18E5E",
};

export default colors;
